module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "simple-list-container"
  }, [_c('source-dialog-form', {
    attrs: {
      "value": _vm.content,
      "dialog-mode": false
    },
    on: {
      "input": function($event) {
        _vm.content = arguments[0]
      }
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Ссылка по ГОСТ:")]), _vm._v(" "), _c('base-text-copy', {
    attrs: {
      "value": _vm.formattedLink,
      "tooltip": "Копировать текст ссылки"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4af241c2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SimpleListContainer.vue
// module id = 1007
// module chunks = 1